import { ContactStatus, ContactType, IContact } from 'models';
import { GetAllFactory, CreateFactory, UpdateFactory, DeleteFactory } from './base.service';
import CrudService from './crud.service';
import { BaseGetAllParams } from './defaults';
import { Api } from './api';
import { message } from 'antd';
import { formatDateForApi } from '../utils/date';

const BASE_URL = 'contacts';
const SERVICE_NAME = 'Contact';

interface GetAllParams extends BaseGetAllParams {
  type?: ContactType;
  text?: string;
}

// Delete this soon
export default new CrudService<IContact>(SERVICE_NAME, BASE_URL);

export const GetAll = GetAllFactory<IContact, GetAllParams>(BASE_URL);
export const Create = CreateFactory<IContact>(BASE_URL, SERVICE_NAME);
export const Update = UpdateFactory<IContact>(BASE_URL, SERVICE_NAME);
export const Delete = DeleteFactory(BASE_URL, SERVICE_NAME);

export const Archive = async (payload: IContact) => {
  const result = await Api.put(`/${BASE_URL}/${payload.id}`, { ...payload, dob: formatDateForApi(payload.dob), status: ContactStatus.Archived });
  message.success(`${SERVICE_NAME} archived successfully`);
  return result;
};
export const Unarchive = async (payload: IContact) => {
  const result = await Api.put(`/${BASE_URL}/${payload.id}`, { ...payload, dob: formatDateForApi(payload.dob), status: ContactStatus.Active });
  message.success(`${SERVICE_NAME} unarchived successfully`);
  return result;
};
